// Runtime config loaded once at app boot. All UI code reads from this
// instead of import.meta.env.VITE_* so the same build runs anywhere.

let _config = null;

export async function loadConfig() {
  if (_config) return _config;
  const res = await fetch('/config.json', { cache: 'no-store' });
  if (!res.ok) {
    throw new Error(`Failed to load /config.json: ${res.status}`);
  }
  _config = await res.json();
  return _config;
}

export function getConfig() {
  if (!_config) {
    throw new Error('getConfig() called before loadConfig() resolved');
  }
  return _config;
}
